import { jsx as _jsx } from "react/jsx-runtime";
import CodeReviewUI from './components/CodeReviewUI';
function App() {
    return (_jsx("div", { className: "min-h-screen bg-gray-900", children: _jsx(CodeReviewUI, {}) }));
}
export default App;
